// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataClients = createAsyncThunk('appUsers/getAllDataClients', async (id) => {
  const response = await axios.get('https://apiv4.opentlv.com/api/v3/user/clients/all', { params: { id} })
  return response.data
})

export const getDataClients = createAsyncThunk('appUsers/getDataClients', async params => {
  const response = await axios.get('https://apiv4.opentlv.com/api/v3/user/clients/data', { params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const addUserToClient = createAsyncThunk('appUsers/addUserToClient', async (group, { getState }) => {
  //  option.client_id = getState()
    console.log("addPrivilgeToGroup")
    
    group.user_id = getState().users.selectedUser.id
    
    
    await axios.post('https://apiv4.opentlv.com/api/v3/user/add/user/client', group)
    //.wait dispatch(getGroupPrivilegesData(getState().groupPrivileges.params))
  
    //await d
  })


export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataClients.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataClients.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
  }
})

export default appUsersSlice.reducer
